import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Lista from './Lista';
import Zadanie from './Zadanie';
import Zadanie_Pop from './Zadanie_Pop';
import Uwagi_Pop from './Uwagi_Pop';
import NavBar from './NavBar';
import Dodaj_plan from './Dodaj_plan';
import axios from 'axios';
import Popup from "reactjs-popup";
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';
import './index.css';
import ChangePswd from './ChangePswd';
import RowwithButton from './RowwithButton';
import apiurl from './apiurl';
import $ from 'jquery';
import update from 'immutability-helper';
import ExelBudzet1 from './export_budzet1.js';
import BudzetPrint from './wydrukiBudzet/BudzetPrint';
import PrintComponents from 'react-print-components';


export default class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
    token: props.token ,
    username: props.username ,
    id: props.id ,      
    rok: props.rok,
    nazwauchwaly: props.nazwauchwaly,  
    nazwastrony: 'App',
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    user: {},
    user4: [],
    data2org: [],
    data2zapis: [],
    datarodz: [],
    idw: "-1",
    Ukryta: 'hide',
    renderZadania: 'nie',
    posortowane: '',
    Wniosek : '',
    pobrano: '',
    reload: '',
    open: false,
    openuwagi: false,
    isLoading: true,
    isLoadingdane: false,
    isLoadingpop: true,
    errors: null, 
    isVisible: false,
    isVisible2: false,
    isVisible3: true,
    formularzpop: true,
    tabelaVisible: true,
    WniosekEdycja: true,
    isLoadingPrzychody: false,
    isVisiblePrzychHead: false,
    loadingdata: false,
    opiniowanieData: null,
    opiniowanieValue: null, 
    opiniowanieStatusData: null,
    loadingStatusyOpinii: true,
    sprawdzam: 'zero',
    dwbp: props.dwbp ? props.dwbp : '2',
    savesuccess: false,
    saveload1: true,
    kolko: true,
    wygenerowanoexcel: false,
    datadoexcel: [],
    uwagiFull: false,
    zadwydz: false,
    czyOpinie: true,
    pominZer: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.closeModalUwagi = this.closeModalUwagi.bind(this);
    this.ZadanieWartosci = this.ZadanieWartosci.bind(this);
    this.zapisdata2 = this.zapisdata2.bind(this);
    this.child = React.createRef();
  }



componentDidMount(){
  ReactDOM.render(<NavBar token = {this.state.token} username = {this.state.username} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} kodoper = {this.state.kodoper} />, document.getElementById("header")); 
  
  if(this.state.dwbp === "1" || this.state.dwbp === "2" || this.state.dwbp === "3" || this.state.dwbp === "4") {
    this.getData()
  }

  if(this.state.dwbp === "5" || this.state.dwbp === "6") {
    this.getDataPrzychody()
  }

  if(this.props.idw) { this.setState({ idw: this.props.idw}) }
  
  this.onLista2();
  this.getrodz();

  $(document).ready(function () {
    $('#pokazszukaj').click(function () {
      $('#szukaj').slideToggle("slow");
    });
  });

  this.czyUwagi();
}


onChangee = (z) => {
  if (z.target.value === '5' || z.target.value === '6'){
    this.setState({ [z.target.name]: z.target.value, Ukryta: 'hide', loadingdata: true }, () => { this.getDataPrzychody() });
  }
  else{
    this.setState({ [z.target.name]: z.target.value, Ukryta: 'hide', reload: 'nie', loadingdata: true }, () => { this.getData() });
  }
}

  onChangeeee = (y) => {
  const zamk = y.target.selectedOptions[0].getAttribute('data-zamk');
  if(this.state.dwbp !== undefined) {
    if ( this.state.dwbp === '5' || this.state.dwbp === '6'){
      let index = y.nativeEvent.target.selectedIndex;
      let label = y.nativeEvent.target[index].text;
      let value = y.target.value;
      this.setState({ idw : value, nazwaw : label, loadingdata: true, czyEdycjaZamknieta: zamk }, () => { this.getDataPrzychody() });
    }
    else{
      let index = y.nativeEvent.target.selectedIndex;
      let label = y.nativeEvent.target[index].text;
      let value = y.target.value;
      this.setState({ idw : value, nazwaw : label, Ukryta: 'hide', reload: 'nie', loadingdata: true, czyEdycjaZamknieta: zamk  }, () => { this.getData() });
    }
  } else {
    if ( this.state.dwbp === '5' || this.state.dwbp === '6'){
      let index = y.nativeEvent.target.selectedIndex;
      let label = y.nativeEvent.target[index].text;
      let value = y.target.value;
      this.setState({ idw : value, nazwaw : label, czyEdycjaZamknieta: zamk });
    }
    else{
      let index = y.nativeEvent.target.selectedIndex;
      let label = y.nativeEvent.target[index].text;
      let value = y.target.value;
      this.setState({ idw : value, nazwaw : label, czyEdycjaZamknieta: zamk });
    }
   }

  }

  onChangeUkryj = (reload) => {
    if (reload) {
      this.setState({ Ukryta: 'hide', renderZadania: 'nie', reload: 'nie' });
      this.odswiez();
    } else {
      if (this.state.Ukryta==='hide'){
        this.setState({ Ukryta: '', renderZadania: 'tak', reload: 'tak'} );
      }
      else{
        this.setState({ Ukryta: 'hide', renderZadania: 'nie', reload: 'nie' });
      }
    }
  }

  hideZadania = () => {
    this.setState({ Ukryta: 'hide', renderZadania: 'nie', reload: 'nie' });
  }

  odswiez = () => {
    if ( this.state.dwbp === '5' || this.state.dwbp === '6'){
    this.setState({ Ukryta: 'hide', reload: 'tak', loadingdata: true }, () => { this.getDataPrzychody() });
    }
    else{
    this.setState({ szudzial : '' , szurozdzial : '' , szuparagraf : '' , szupozycja : '' , szurodzaj : '', loadingdata: true }, () => { this.getData() });
    }
  }

  onLista2 = () => {
    axios
      .get(apiurl+"api/Listy/GetWydzialy4ddl", { params : { rok : this.state.rok, idUchwal: this.state.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
      .then(response => {
        if(response.data.length === 1) {
          this.setState({ idw: response.data[0].value })
        }
        const data3 = response.data.map(data => ({
          idw: `${data.idWydzialu}`,
          nazwaw: `${data.nazwa}`,
          editable: `${data.editable}`,
        }));
        this.setState({  data3, isLoading: false });
      }
      )
      .catch(error => swal(error.response.data) , this.setState({ isLoading: false }));
  }

getData() {
  this.setState({ loadingdata : true })
  axios
    .get(apiurl+"api/Budzet?", {params : {rok : this.state.rok, idUchwaly : this.state.id, idWydz : this.state.idw, DWBP : this.state.dwbp}, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      response.data.map(data => ({
        IDA: `${data.id}`,
        DW: `${data.dw}`,
        BP: `${data.bp}`,
        Dzial: `${data.dzial}`,
        Rozdzial: `${data.rozdzial}`,
        Paragraf: `${data.paragraf}`,
        Pozycja: `${data.pozycja}`,
        idRodzaju: `${data.idRodzaj}`,
        Rodzaj: `${data.rodzajNazwa}`,
        idWydzialu: `${data.idWydzial}`,
        Wydzial: `${data.wydzial}`,
        Opis: `${data.opis}`,
        Przed: `${data.przed}`.replace('.', ','),
        Zmiany: `${data.zmiany}`.replace('.', ','),
        Po: `${data.po}`.replace('.', ','),
        poWniosku: `${data.poWniosku}`.replace('.', ','),
        P4: `${data.p4}`, 
        Wniosek: `${data.wniosek}`.replace('.', ','),
        uchWydzStat: `${data.uchWydzStat}`,
        uchWydzStatZad: `${data.uchWydzStatZad}`,
        Ukryta: 'hide',
      }))
    )
    .then(data => {
      const resdata = data;
      if (resdata==''){
        this.setState({ loadingdata: false, isLoadingdane: false, isVisible: false, isVisible2: true, isVisible3: false, isLoadingPrzychody: false, isVisiblePrzychHead: false });
      } 
      else{
        this.setState({ data2: resdata, loadingdata: false, data2org : resdata, data2zapis: resdata, isLoadingdane: true, isLoadingPrzychody: false, isVisible: true, isVisible2: false, isVisible3: false, isVisiblePrzychHead: false });
      }
    })
    .catch(error => swal(error.response.data.message) , this.setState({ isVisible3: true }));
  }


getDataPrzychody() {

  axios
    .get(apiurl+"api/BudzetPR?", {params : {rok : this.state.rok, idUchwaly : this.state.id, idWydzialu : this.state.idw, DWBP : this.state.dwbp}, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      response.data.map(data6 => ({
        IDP: `${data6.id}`,
        Paragraf: `${data6.paragraf}`,
        Pozycja: `${data6.pozycja}`,
        Wydzial: `${data6.wydzial}`,
        Opis: `${data6.opis}`,
        Wniosek: `${data6.wniosek}`.replace('.', ','),
        Przed: `${data6.przed}`.replace('.', ','),
        Zmiany: `${data6.zmiany}`.replace('.', ','),
        Po: `${data6.po}`.replace('.', ','),
        poWniosku: `${data6.poWniosku}`.replace('.', ','), 
      }))
    )
    .then(data6 => {
      if (data6==''){
        this.setState({ loadingdata: false, isLoadingdane: false, isVisible: false, isVisible2: true, isVisible3: false, isLoadingPrzychody: false, isVisiblePrzychHead: false });
      }
      else{
        this.setState({ data6, loadingdata: false, isLoadingdane: false, isLoadingPrzychody: true, isVisible: false, isVisible2: false, isVisible3: false, isVisiblePrzychHead: true });
      }
    })
    .catch(error =>swal(error.response.data), this.setState({ isVisible3: true }));
}


  wroc = () => {
    ReactDOM.render(<Lista  token = {this.state.token} username = {this.state.username} rok = {this.state.rok}/>, document.getElementById("root"));
  }

  dodaj = () => {
    ReactDOM.render(<Dodaj_plan token = {this.state.token} username = {this.state.username} rok = {this.state.rok} idUchwaly = {this.state.id} nazwauchwaly = {this.state.nazwauchwaly} dwbp={this.state.dwbp} idw={this.state.idw} wersjaTabeli={this.props.wersjaTabeli} />, document.getElementById("root"));
  }

  zmienhaslo = () => {
    ReactDOM.render(<ChangePswd token = {this.state.token} username = {this.state.username}  kodoper={this.state.kodoper} id={this.state.id} rok={this.state.rok} nazwastrony={this.state.nazwastrony}/>, document.getElementById("root"));
  }
  

  closeModal () {
    this.setState({ open: false })
  }

  closeModalUwagi () {
    this.setState({ openuwagi: false })
  }

  uwagi() {
    if(this.state.idw === "-1") { swal("Wybierz wydział") }
    else{ 
      if(this.state.dwbp === undefined) {swal("Wybierz rodzaj dokumentu.")}
      else {
        this.setState({openuwagi: true})
      }
    }
  }

  koniecedycji() {
    if(this.state.idw === "-1") { swal("Wybierz wydział") }
    else{
      swal("Czy chcesz zamknąć edycję dla wydziału: " + this.state.nazwaw, {
        closeOnClickOutside: false,
        buttons: {
          cancel: "Anuluj",
          do: {
            text: "Zakończ edycje",
            value: "do",
          },
        },
      })
      .then((value) => {
        switch (value) {
          case "do":
            this.koniecedycjipost();
            break;
        }
      });
    }
  }

  koniecedycjipost() {
    axios.post(apiurl+"api/BudzetEdycja/ZamknijEdycje",
      {rok: this.state.rok, idUchwaly: this.state.id, idWydzialu: this.state.idw },
      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
      .then(res => {
        swal(res.data);
      })
      .catch(error => swal(error.response.data));
  }

  sortowanieCyfry = (id) => {
    const { data2, posortowane } = this.state;
    if (posortowane === 'tak'){
    data2.sort((a, b) => {
      return parseFloat(a[id], 10).toFixed(0)  - parseFloat(b[id], 10).toFixed(0);
    })
    this.setState({ data2, posortowane: '', reload: 'nie' })
    }
    else {
    data2.sort((a, b) => {
      return parseFloat(b[id], 10).toFixed(0)  - parseFloat(a[id], 10).toFixed(0);
    })
    this.setState({ data2, posortowane: 'tak', reload: 'nie' })
    }
  }

  sortowanieNazwy = (id) => {
    const { data2, posortowane } = this.state;
    if (posortowane === 'tak'){
      data2.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )).reverse();
    this.setState({ data2, posortowane: '' })
    }
    else {
    data2.sort((a, b) => a[id].localeCompare(b[id], 'pl', { sensitivity: 'base' } )); 
    this.setState({ data2, posortowane: 'tak' })
    }  
  }

  onChange(z) { this.setState({ [z.target.name]: z.target.value }) }

  szukajka() { 
    let { szudzial, szurozdzial, szuparagraf, szupozycja, szurodzaj } = this.state;
    let data2 = this.state.data2org.slice();
    if(szudzial) {
      data2 = data2.filter(item => item.Dzial.toLowerCase().includes(szudzial) );
    }
    if(szurozdzial) {
      data2 = data2.filter(item => item.Rozdzial.toLowerCase().includes(szurozdzial) );
    }
    if(szuparagraf) {
      data2 = data2.filter(item => String(item.Paragraf+item.P4).toLowerCase().includes(szuparagraf) );
    }
    if(szupozycja) {
      data2 = data2.filter(item => item.Pozycja.toLowerCase().includes(szupozycja) );
    }
    if(szurodzaj) {
      data2 = data2.filter(item => item.Rodzaj.toLowerCase().includes(szurodzaj.toLowerCase()) );
    }
    this.setState({ data2 }, this.zapisdata2(data2));

    if(data2.length < 1) { swal("Brak wyników.")}
  }

  resetszukajka() { 
    let { data2org } = this.state;
    this.setState({ szudzial : '' , szurozdzial : '' , szuparagraf : '' , szupozycja : '' , szurodzaj : '', data2 : data2org}, this.zapisdata2(data2org))
  }

  getrodz = async () => {
    const res = await axios.get(apiurl+"api/Listy/GetSlownikRodzaje?", { params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }}).catch(error => this.setState({ error,  }));
    let datarodz = res.data.map( category => ({ rodzajvalue: category.value, nazwarodzaj: category.text}));
    this.setState({datarodz});
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.szukajka();
    }
  }

  updatewartosci = (dataget) => {
  this.setState({ pobrano: 'tak', renderZadania: 'nie', reload: 'nie' });
    var data = this.state.data2;
    const dzials = dataget.dzial;
    const rozdzials = dataget.rozdzial;
    const paragrafs = dataget.paragraf;
    const pozycjas = dataget.pozycja;
    const wydzials = dataget.wydzial;
    const rodzajs = dataget.idRodzaj;
    
    const commentIndex =  data.findIndex(i => i.Dzial === dzials && i.Rozdzial === rozdzials && i.Paragraf === paragrafs && i.Pozycja === pozycjas && i.Wydzial === wydzials && i.idRodzaju === rodzajs  );
    
    const wniosekbezkropka = dataget.wniosek;
    const wniosekkropka = wniosekbezkropka.toFixed(2);
    const wniosekprzecinek = wniosekkropka.replace('.', ',');

    var updatedComment = update(data[commentIndex], {Wniosek: {$set: wniosekprzecinek}}); 
    var newData = update(data, {
        $splice: [[commentIndex, 1, updatedComment]]
    });

    this.setState({data2: newData});

    this.zapisdata2(newData);
  }

  ZadanieWartosci(idWydzialu, idRodzaju, Dzial, Rozdzial, Paragraf, P4, Pozycja) {
    this.setState({ idWydzialupop: idWydzialu, idRodzpop: idRodzaju, dzialpop: Dzial, rozdzialpop: Rozdzial, pragrafp4pop: Paragraf + P4, pozycjapop: Pozycja, open: true, reload: "nie", formularzpop: true })
  }

ChangeWniosek = (wniosek, ida) => {
  var data = this.state.data2;

  const commentIndex =  data.findIndex(i => i.IDA === ida );

  var updatedComment = update(data[commentIndex], {Wniosek: {$set: wniosek}}); 
  var newData = update(data, {
    $splice: [[commentIndex, 1, updatedComment]]
  });

  this.setState({
    data2 : newData
  });
}

zapisdata2 (data) {
  this.setState({ data2zapis: data })
}

zapisdata2state = () => {
  let { data2 } = this.state;
  this.setState({ data2zapis: data2 })

}

sumaall = (data, key) => {
  let total = 0;
  data.forEach((item, idx) => {
    let itemdot = item[key].replace(',', '.');
    let itemnum = parseFloat(itemdot);
    total += itemnum;
    total = parseFloat(total.toFixed(2));
  });
  return total;
};

genExcel = (data) => {

  let dataexcel = [
    ...data, {
      Opis: 'SUMA',
      Przed: this.sumaall(data, 'Przed'),
      Zmiany: this.sumaall(data, 'Zmiany'),
      Po: this.sumaall(data, 'Po'),
      poWniosku: this.sumaall(data, 'poWniosku'),
      Wniosek: this.sumaall(data, 'Wniosek'),
    }
  ]

  return dataexcel
}

czyUwagi() {
  const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];

   this.setState({ 
        noweUwagi: konfig.noweUwagi, 
        ukryjPlan: konfig.ukryjPlan,
        zadwydz: konfig.zadwydz,
        czyOpinie:konfig.opinie,
  })

  // axios
  //   .get(apiurl+"api/Konfig", {params : {rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
  //   .then(response =>
  //     this.setState({ 
  //       noweUwagi: response.data.noweUwagi, 
  //       ukryjPlan: response.data.ukryjPlan,
  //       zadwydz: response.data.zadwydz,
  //       czyOpinie: response.data.opinie,
  //      })
  //   )
  //   .catch(error =>swal(error.response.data), this.setState({ isVisible3: true }));

}

opiniowanie() {

  axios
    .get(apiurl+"api/Opinie2/Opiniodawcy", { params: { rok: this.state.rok, idUchwaly: this.state.id, idWydzialu: this.state.idw }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ opiniowanieData: response.data })
    )
    .catch(error =>swal(error.response.data), this.setState({ isVisible3: true }));

}

postOpiniowanie = (e) => {
  e.preventDefault();
  const data = JSON.parse(this.state.opiniowanieValue);
  const dataNow = new Date();
  const { opiniowanieValue } = this.state;

  axios.post(apiurl+"api/Opinie2/Post1", {
    id: null,
    rok: Number(this.state.rok),
    idUchwaly: Number(this.state.id),
    idWydzialu: Number(this.state.idw),
    idOpiniodawcyDo: data.idOpiniodawcy,
    kodOperDo: data.kodOper,
    dataOtw: dataNow,
    kodOper: null,
    idOpiniodawcy: null,
    uwagi: null,
    status: null,
    dataZamk: null,
    nazwaWydzialu: null,
    nazwaUchwaly: null,
  },
  {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
  .then(res => {
    swal('Zapisano')
  })
  .catch(error => {
    // if(error.response.data === 2390) {
    //   swal({
    //     title: 'Nieprawidłowy status. Czy chcesz dla danego dokumentu ustawić status na: "W opiniowaniu"?',
    //     buttons: {
    //     cancel: "Anuluj",
    //     catch: {
    //       text: "Tak",
    //       value: "willDelete",} 
    //     },
    //     dangerMode: true,
    //   })
    //   .then((willDelete) => {
    //     if (willDelete) {
    //       axios
    //       .get(apiurl+"api/Opinie2/SetStatusDoOpiniowania", { params: { rok: this.state.rok, idUchwaly: this.state.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    //       .then(response => {
    //         swal(response.data);
    //         this.postOpiniowanie(e)
    //       })
    //       .catch(error => swal(error.response.data));
    //     } else { return null }
    //   });
    // } else { 
    //   swal(error.response.data) 
    // }
      swal(error.response.data) 
  });
}

deleteOpiniowanie() {

swal({
  title: 'Czy na pewno chcesz usunąć wszystkie opinie dla tego dokumentu?',
  buttons: {
  cancel: "Anuluj",
  catch: {
    text: "Tak",
    value: "willDelete",} 
  },
  dangerMode: true,
})
.then((willDelete) => {
  if (willDelete) {
    axios.delete(apiurl + "api/Opinie2/UsunOpinie", { params: { rok: this.state.rok, idUchwaly: this.state.id }, headers: { 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      swal(res.data);
    })
    .catch(error => swal(error.response.data))
  } else { return null }
});

}



opiniowanieStatus() {
  this.setState({ loadingStatusyOpinii: true });

  axios
    .get(apiurl+"api/Opinie2/StatusyOp", { params: { rok: this.state.rok, idUchwaly: this.state.id }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ opiniowanieStatusData: response.data, loadingStatusyOpinii: false })
    )
    .catch(error =>swal(error.response.data), this.setState({ loadingStatusyOpinii: false }));

}




render() {

const { noweUwagi, data2, data3, data2zapis, data6, dwbp, idw, datarodz, opiniowanieData, opiniowanieStatusData, 
        loadingStatusyOpinii, opiniowanieValue, nazwauchwaly, loadingdata, szudzial, szurozdzial, szuparagraf, szupozycja, 
        szurodzaj, ukryjPlan, zadwydz, czyOpinie, pominZer, czyEdycjaZamknieta } = this.state;

const { wersjaTabeli, sorta } = this.props;

return (
  
<React.Fragment>
  
<div class="container-fluid">
<h2>{nazwauchwaly}</h2>
<hr />
{czyOpinie && <div class="d-flex flex-row p-1 mb-2">
<button type="button" class="btn btn-light"  data-toggle="modal" data-target="#opinieStatusyModal" onClick={() => (this.opiniowanieStatus())}> Statusy opinii </button>
</div>}
<div class="d-flex flex-wrap">
<div class="p-1">
<button class="btn btn-light" onClick={() => this.wroc()}> Wróć </button>
</div>
<div class="p-1">
    <select  type="select" class="form-control" onChange={this.onChangee.bind(this)} name="dwbp" value={dwbp}>
    <option key="1" defaultValue="Wybierz" hidden="hidden" >Wybierz</option>
    {/* <option key="2" value="1" >Dochody budżetowe</option>
    <option key="3" value="2" >Wydatki budżetowe</option> */}
    <option key="2" value="1" >Dochody</option>
    <option key="3" value="2" >Wydatki</option>
    <option key="4" value="3" >Dochody pozabudżetowe</option>
    <option key="5" value="4" >Wydatki pozabudżetowe</option>
    <option key="6" value="5" >Przychody</option>
    <option key="7" value="6" >Rozchody</option>
  </select>
</div>

<div class="p-1">
<select type="select" class="form-control" onChange={this.onChangeeee.bind(this)} value={idw}>
{data3 && data3.length === 1 ? null : (<option key="-1" value="-1">Wszystkie wydziały</option>)}
{data3.map(user2 => {
  const { idw, nazwaw, editable} = user2;
    return (
    <option key={idw} value={idw} data-zamk={editable} >{nazwaw}</option>
    );
    })}
</select>   
</div>

<div class="p-1">
<button class="btn btn-light" onClick={() => this.dodaj()}> Dodaj </button>
</div>
<div class="p-1">
<button class="btn btn-light" onClick={() => this.onChangeUkryj(false)}> Pokaż / Ukryj zadania </button>
</div>
<div class="p-1">
<button class="btn btn-light" onClick={() => this.onChangeUkryj(true)}> Odśwież </button>
</div>
<div class="p-1">
<button class="btn btn-light" onClick={() => this.koniecedycji()}> Zakończ edycję </button>
</div>
{czyOpinie && <div class="p-1">
  {this.state.idw !== '-1' ? (<button type="button" class="btn btn-light" onClick={() => this.opiniowanie()} data-toggle="modal" data-target="#opiniowanieModal"> Prześlij do opiniowania</button>) : 
  (<button type="button" class="btn btn-light" disabled> Prześlij do opiniowania </button>)}
</div>}
{noweUwagi? null : (<div class="p-1">
<button class="btn btn-light" onClick={() => this.uwagi()}> Uwagi </button>
</div>)}
<div class="p-1" id="pokazszukaj">
{dwbp === '5' || dwbp === '6' ? null : (<i class="fas fa-search szukajka"  onClick={() => (this.setState({ szudzial : '' , szurozdzial : '' , szuparagraf : '' , szupozycja : '' , szurodzaj : '' }))}></i>
)}
</div>
</div>
<br />
<div id="szukaj" className="szukajbudzet">
  <div className="row">
  <span className="ml-3">Szukaj: </span>
  </div>
  <div className="row m-1 mb-2">
    <div class="col-1">
    <input type="text" name="szudzial" className="form-control" placeholder="Dział" value={szudzial} onChange={(z) => (this.onChange(z))} onKeyDown={this._handleKeyDown}></input>
    </div>
    <div class="col-1">
    <input type="text" name="szurozdzial" className="form-control " placeholder="Rozdział" value={szurozdzial} onChange={(z) => (this.onChange(z))} onKeyDown={this._handleKeyDown}></input>
    </div>
    <div class="col-1">
    <input type="text" name="szuparagraf" className="form-control " placeholder="Paragraf" value={szuparagraf} onChange={(z) => (this.onChange(z))} onKeyDown={this._handleKeyDown}></input>
    </div>
    <div class="col-1">
    <input type="text" name="szupozycja" className="form-control " placeholder="Pozycja" value={szupozycja} onChange={(z) => (this.onChange(z))} onKeyDown={this._handleKeyDown}></input>
    </div>
    <div class="col-2">
    <select type="select" class="form-control" name="szurodzaj" value={szurodzaj} onChange={(z) => (this.onChange(z))}>
      <option key="-1" value="">Wszystkie rodzaje</option>
      {datarodz.map(data => {
      const { nazwarodzaj } = data;
      return (
      <option value={nazwarodzaj} > {nazwarodzaj}</option>
      );
      })}
    </select>
    </div>

    <div class="form-group form-check ml-2 mr-2 d-flex flex-row pointer" onChange={() => (this.setState(prevState => ({ pominZer: !prevState.pominZer })))}>
      <input type="checkbox" class="form-check-input" id="pominZerowe" checked={pominZer} ></input>
      <label class="form-check-label text-nowrap" for="pominZerowe">Pomiń stany zerowe</label>
    </div>

    <div class="col-3">
    <button type="button" className="btn btn-light mr-1" onClick={() => (this.szukajka())} >Szukaj</button>
    <button type="button" className="btn btn-light ml-1" onClick={() => (this.resetszukajka())}>Resetuj filtry</button>
    </div>
  </div>
</div>

  {(!czyEdycjaZamknieta && data2.length > 0 && idw !== '-1') && <div class="alert alert-warning" role="alert">Edycja dla tego wydziału jest zamknięta.</div>}

<div class="table-responsive card">
{loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }
{ this.state.isVisible ? (<><div className="m-1">
<ExelBudzet1 data={this.genExcel(data2zapis)} />  
<PrintComponents trigger={<button type="button" class="btn btn-light float-right mt-2"><i class="fas fa-print"></i> Drukuj</button>} >
  <BudzetPrint data={data2} nazwauchwaly={nazwauchwaly} />
</PrintComponents>
</div>
</>) : null }
<table id="Tabela" class="table table-hover table-sm">   
<thead>
{ this.state.isVisible ? (
  <tr >
    <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Dzial')}><b>Dział</b></th>
    <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Rozdzial')}><b>Rozdział</b></th>
    <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Paragraf')}><b>Paragraf</b></th>
    <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Pozycja')}><b>Pozycja</b></th>
    <th scope="col" class="text-center point" width="10%" onClick={() => this.sortowanieNazwy('Rodzaj')}><b>Rodzaj</b></th>
    <th scope="col" class="text-center point" width="15%" onClick={() => this.sortowanieNazwy('Wydzial')}><b>Wydział</b></th>
    <th scope="col" class="text-center point" width="30%" onClick={() => this.sortowanieNazwy('Opis')}><b>Opis</b></th>
    {!wersjaTabeli ? (<th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Przed')}><b>Plan ubiegłoroczny</b></th>) : (<th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Przed')}><b>Przed</b></th>)}
    {wersjaTabeli && <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Po')}><b>Po</b></th>}
    {wersjaTabeli ? null : ukryjPlan ? null : <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('poWniosku')}><b>Po Wniosku</b></th>}    
    {ukryjPlan ? null : !wersjaTabeli ? (<th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Zmiany')}><b>Plan</b></th>) : (<th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Zmiany')}><b>Zmiany</b></th>)}    
    <th scope="col" class="text-center point" width="5%" onClick={() => this.sortowanieCyfry('Wniosek')}><b>Wniosek</b></th>
    <th scope="col" class="text-center"></th>
  </tr>

) : null }

{ this.state.isVisiblePrzychHead ? (
  <tr >
    <th scope="col" class="text-center"><b>Paragraf</b></th>
    <th scope="col" class="text-center"><b>Pozycja</b></th>
    <th scope="col" class="text-center"><b>Wydzial</b></th>
    <th scope="col" class="text-center"><b>Opis</b></th>
    <th scope="col" class="text-center"><b>Wniosek</b></th>
    {!wersjaTabeli ? (<th scope="col" class="text-center"><b>Plan ubiegłoroczny</b></th>) : (<th scope="col" class="text-center"><b>Przed</b></th>)}
    {ukryjPlan ? null : !wersjaTabeli ? (<th scope="col" class="text-center"><b>Plan</b></th>) : (<th scope="col" class="text-center"><b>Zmiany</b></th>)}
    {sorta === '2' && ukryjPlan || sorta === '4' && ukryjPlan ? null :!wersjaTabeli ? null : (<th scope="col" class="text-center"><b>Po</b></th>)}
    {!wersjaTabeli ? null : (<th scope="col" class="text-center"><b>Po wniosku </b></th>)}    
  </tr>
) : null }
</thead>
<tbody>

{this.state.isLoadingdane ? (<>
  {data2.filter(val => !pominZer || Number(val.Wniosek) !== 0).map((user, idx) => {
  const { IDA, Rozdzial, Dzial, Paragraf, idRodzaju, Rodzaj, Wydzial, Opis, Przed, Po, P4, Wniosek, Pozycja, idWydzialu, poWniosku, Zmiany, uchWydzStat, uchWydzStatZad} = user;
  const { Ukryta, rok, id, dwbp, token, renderZadania, pobrano, reload } = this.state;
  return (
    <React.Fragment key={IDA}>
      <tr>
        <RowwithButton idx={idx} user={user} rok={this.state.rok} id={this.state.id} dwbp={this.state.dwbp} token={this.state.token} 
          ZadanieWartosci={this.ZadanieWartosci} zapisdata2state={this.zapisdata2state} ChangeWniosek={this.ChangeWniosek} 
          wersjaTabeli={wersjaTabeli} noweUwagi={noweUwagi} sorta={sorta} ukryjPlan={ukryjPlan} openZadWydz={this.openZadWydz}
          zadwydz={zadwydz} idw={idw}
        />
      </tr>  
      <tr class={Ukryta} key={IDA} >
        <td colSpan="12" className="bezramy zad-bg">
          <Zadanie apiurl={this.props.apiurl} updatewartosci={this.updatewartosci} hideZadania={this.hideZadania} idUchwaly={id} rok = {rok} token = {token} id = {id} dwbp = {dwbp} dzial = {Dzial} rozdzial = {Rozdzial} paragraf = {Paragraf}  p4 = {P4} pozycja = {Pozycja} idWydz = {idWydzialu} idRodz = {idRodzaju} renderZadania={renderZadania} pobrano={pobrano} reload={reload} IDA = {IDA}/>
          </td>
          <td colSpan="1" className="bezramy zad-bg">
          {uchWydzStatZad === 'true' ? (<button class="btn btn-light button-text" onClick={() => this.setState({ idWydzialupop: `${user.idWydzialu}`, idRodzpop: `${user.idRodzaju}`, dzialpop: `${user.Dzial}`, rozdzialpop: `${user.Rozdzial}`, pragrafp4pop: `${user.Paragraf}`+`${user.P4}`, pozycjapop: `${user.Pozycja}`, open: true, reload: "nie", formularzpop: false })}> Dodaj zadanie </button> ) : null }
        </td>
      </tr>
    </React.Fragment>
      );
    })}
    <tr >
      <td colSpan="7" className="text-right"><b>SUMA:</b></td>
      <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data2zapis, 'Przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      {!wersjaTabeli ? null : (<td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data2zapis, 'Po')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>)}
      {wersjaTabeli ? null : ukryjPlan ? null : (<td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data2zapis, 'poWniosku')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>)}
      {ukryjPlan ? null : <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data2zapis, 'Zmiany')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>}
      <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data2zapis, 'Wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td colSpan="1" className="text-right"></td>
    </tr>
    </>) : null }

{ this.state.isVisible2 ? ( <tr ><td colSpan="13"><center><p>Brak danych</p></center></td></tr> ) : null }
{ this.state.isVisible3 ? ( <tr ><td colSpan="13"><center><p>Wybierz wartości</p></center></td></tr> ) : null }

{ this.state.isLoadingPrzychody ? (<>
  {data6.map(user6 => {
  const { IDP, Paragraf, Pozycja, Wydzial, Opis, Wniosek, Przed, Zmiany, Po, poWniosku } = user6;
  return (
    <>
     <tr id={IDP}>
        <td ><p>{Paragraf}</p></td>
        <td ><p>{Pozycja}</p></td>
        <td ><p>{Wydzial}</p></td>
        <td ><p>{Opis}</p></td>
        <td class="text-right kwoty"><p><NumberFormat value={Wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
        <td class="text-right kwoty"><p><NumberFormat value={Przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
        <td class="text-right kwoty"><p><NumberFormat value={Zmiany} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
        {sorta === '2' && ukryjPlan || sorta === '4' && ukryjPlan ? null : !wersjaTabeli ? null : (<td class="text-right kwoty"><p><NumberFormat value={Po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>)}
        {!wersjaTabeli ? null : (<td class="text-right kwoty"><p><NumberFormat value={poWniosku} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>)}
      </tr>  
 
    </>
      );
    })}
    <tr >
    <td colSpan="4" className="text-right"><b>SUMA:</b></td>
    <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data6, 'Wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
    <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data6, 'Przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
    <td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data6, 'Zmiany')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
    {sorta === '2' && ukryjPlan || sorta === '4' && ukryjPlan ? null :  !wersjaTabeli ? null : (<td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data6, 'Po')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>)}
    {!wersjaTabeli ? null : (<td colSpan="1" className="text-right"><NumberFormat value={this.sumaall(data6, 'poWniosku')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>)}

  </tr>
    </>) : null }

    </tbody>
    </table>
    </div>
<Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal}>
<div class="okno table-responsive">
<a class="close point m-3" onClick={this.closeModal}>
&times;
</a>

<Zadanie_Pop apiurl={this.props.apiurl} token={this.state.token} updatewartosci={this.updatewartosci} 
  rok= {this.state.rok} idUchwaly= {this.state.id} dzial = {this.state.dzialpop} rozdzial = {this.state.rozdzialpop} 
  paragrafP4 = {this.state.pragrafp4pop} pozycja = {this.state.pozycjapop} dwbp = {this.state.dwbp} 
  idWydz = {this.state.idWydzialupop} idRodz = {this.state.idRodzpop} formularzpop = {this.state.formularzpop}
  closeModal={this.closeModal}
/>

</div>
</Popup>

<Popup open={this.state.openuwagi} closeOnDocumentClick onClose={this.closeModalUwagi}>
<div class="okno">
<a class="close point" onClick={this.closeModalUwagi}>
&times;
</a>
<Uwagi_Pop apiurl={this.props.apiurl} token={this.state.token} rok= {this.state.rok} idUchwaly= {this.state.id} idWydzial= {this.state.idw} nazwaw = {this.state.nazwaw} dwbp={this.state.dwbp} />
</div>
</Popup>


<div class="modal" tabindex="-1" role="dialog" id="opiniowanieModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Opiniowanie</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body m-3">
        {/* {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); const opiniowal = data.czyOpiniowal ? "T" : "N"; return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, Operator: {data.nazwaOperatora}, Opiniował: {opiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) } */}
        {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, Operator: {data.nazwaOperatora}, {data.czyOpiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger mr-auto" onClick={(e) => (this.deleteOpiniowanie(e))}>Usuń</button>
        {opiniowanieValue ? (<button type="button" class="btn btn-primary" onClick={(e) => (this.postOpiniowanie(e))}>Zapisz</button>) : (<button type="button" class="btn btn-primary" disabled>Zapisz</button>)}
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Zamknij</button>  
        
      </div>
    </div>
  </div>
</div>



<div class="modal" tabindex="-1" role="dialog" id="opinieStatusyModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Opiniowanie statusy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body m-3">
      <table className='table table-striped'>
        <thead>
            <tr>
              <th>Opiniodawca</th>
              <th>Nazwa wydziału</th>
              <th>Opis</th>
              <th>Status</th>
            </tr>
        </thead>
        <tbody>
        {loadingStatusyOpinii ? (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) : 
        (<>{opiniowanieStatusData && opiniowanieStatusData.length > 0 ? (<>{opiniowanieStatusData.map((data, idx) => {
          const uwagishort = data.uwagi.substring(0,10);
          const uwagiFull = this.state;
          return (<tr key={idx}>
              <td>{data.opiniodawca}</td>
              <td>{data.nazwaWydz}</td>
              <td >{data.uwagi.length > 10 ? (<>{uwagiFull ? (<span>{data.uwagi}</span>) : (<span>{uwagishort}...</span>)}</>) : (<span>{data.uwagi}</span>)}</td>
              <td>{data.status}</td>
          </tr>)
        })}</>) : (<p>Brak danych.</p>)}</>)}
        </tbody>
      </table>
      </div>
    </div>
  </div>
</div>

</div>




</React.Fragment>
    );
  }
}

